import { useQuery } from '@tanstack/react-query';
import API from '../../../../utils/constant';
import type { ChapterRow } from '../types';

export function useSchoolChapters(subjectId: number | null) {
  return useQuery({
    queryKey: ['exam_gen', 'chapters', subjectId],
    queryFn: () =>
      API.get<{ chapters: ChapterRow[] }>(
        `/api/school/subjects/${subjectId}/chapters/`).then(r => r.data.chapters),
    enabled: !!subjectId,
  });
}
